module.exports = __webpack_public_path__ + "img/0元试用@2x.a980dbff.png";